<template>
  <b-form-group class="list-select">
    <b-form-select 
      :id="selectId"
      v-model="propiedad" 
      :options="lista">
      <!-- <template slot="first">
        <option v-if="nullOption" :value="null">{{ label }}</option>
      </template> -->
    </b-form-select>
    <b-input-group-append 
        class="filter-search-icons">
      <b-input-group-text>
        <i class="fa fa-check" @click="seleccionar"></i>
      </b-input-group-text>
      <b-input-group-text>
        <i class="fa fa-times" @click="cancelar"></i>
      </b-input-group-text>
    </b-input-group-append>
  </b-form-group>
</template>

<script>
export default {
  props: {
    selectId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    nombre: {
      type: String,
      default: ''
    },
    lista: {
      type: Array,
      default: null
    },
    nullOption: {
      type: Boolean,
      default: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      propiedad: '',
      updating: false
    }
  },
  created() {
      this.updating = true;
      this.propiedad = this.nombre;
      this.updating = false;
  },
  computed: {
  },     
  methods: {
    validate() {
      this.$emit('validate');
    },
    seleccionar() {
      this.$emit('updated', this.propiedad);
    },
    cancelar() {
      this.$emit('close');
    }
  },
  watch: {
    'nombre' : function(newVal, oldVal) {
      this.updating = true;
      this.propiedad = newVal;
      this.updating = false;
    },
    // 'propiedad' : function(newVal, oldVal) {
    //   if (newVal != oldVal && !this.updating) {
    //     this.$emit('updated', this.propiedad);
    //   }
    // },
  }    
}
</script>

<style>
  .list-select {
    margin-bottom: 5px;
  }
  .list-select div {
    display: flex;
  }
  .list-select select {
    font-size: 0.8em;
  }
  .list-select .input-group-text {
    background-color: transparent;
    border: none;
    font-size: 0.8em;
    padding-left: 6px;
    padding-right: 6px;    
  }
  .list-select .input-group-text:first-of-type {
    color: green;
    margin-left: 3px;
  }
  .list-select .input-group-text:last-of-type {
    color: red;
  }
</style>
